import { Modal, Input, DatePicker } from "antd";
import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import { ActiveStepStore } from "src/store/onboarding.store";
import TrendUp from "@assets/icons/trendUp";
import { ArrowRight } from "lucide-react";

interface MarketShareModalProps {
  open: boolean;
  onClose: () => void;
  setGoalValue: (value: number | null) => void;
}

const MarketShareModal = ({
  open,
  onClose,
  setGoalValue,
}: MarketShareModalProps) => {
  const [showConfetti, setShowConfetti] = useState(false);
  const setStep = ActiveStepStore((state) => state.setStep);
  const step = ActiveStepStore((state) => state.step);

  const handleClose = () => {
    if (step === 4) {
      setShowConfetti(true);
      setStep(5);
    }
    onClose();
  };

  useEffect(() => {
    if (showConfetti && step === 5) {
      const timeout = setTimeout(() => setShowConfetti(false), 3000);
      return () => clearTimeout(timeout);
    }
  }, [showConfetti, step]);

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={handleClose}
      closable
      className={styles.modal}
      centered
    >
      <div className={styles.wrapper}>
        <h2 className={styles.title}>Market Share Goal</h2>

        <label htmlFor="market-share-goal" className={styles.label}>
          Enter your Goal (%)
        </label>
        <Input
          placeholder="10%"
          className={styles.input}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setGoalValue(e.target.value ? parseFloat(e.target.value) : null)
          }
        />

        <div className={styles.resultBox}>
          <div className={styles.res}>
            <span>Market, share, sum, $</span>
            <div className={styles.flexin}>
              <span>
                $15M <ArrowRight size={12} />
              </span>
              <span className={styles.success}>
                $17M <TrendUp />
              </span>
            </div>
          </div>
        </div>

        <div className={styles.dateRow}>
          <DatePicker placeholder="Start date" className={styles.dateInput} />
          <DatePicker placeholder="End date" className={styles.dateInput} />
        </div>

        <button className={styles.cta} onClick={handleClose}>
          SETUP GOAL
        </button>
      </div>
    </Modal>
  );
};

export default MarketShareModal;
